// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

import type { GetEngagementCanvasSendToDestinationRelatedCanvasesResult, RelatedCanvasItem } from "./types";

export const isGetEngagementCanvasSendToDestinationRelatedCanvasesResult =
  objectOf<GetEngagementCanvasSendToDestinationRelatedCanvasesResult>({
    related_canvases: arrayOf(
      objectOf<RelatedCanvasItem>({
        name: string,
        step_name: string,
        id: string,
        step_id: string,
      })
    ),
  });
